<template>
    <div v-if="pending">
        <div class="d-flex justify-content-center loading-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
	<div v-else class="container py-5">
        <h2>{{ $t('selectionCreate') }}</h2>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <RouterLink to="/modelings">
                        {{ $t('home') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">
                    <RouterLink :to="{ name: 'modeling', params: { id: this.$route.params.id } }">
                        {{ modelingName || $t('modelings') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">{{ $t('create') }}</li>
            </ol>
        </nav>
        <div class="row mb-4">
            <div class="mb-3 col-md-4">
                <label class="form-label" for="name" required>{{ $t('name') }}</label>
                <input v-model="data.name" type="text" class="form-control" id="name" >
            </div>
            <div class="mb-3 col-md-4">
                <label class="form-label" for="selectionMethod" required>{{ $t('selectionMethod') }}</label>
                <select v-model="data.selectionMethod" class="form-select">
                    <option value="">{{ $t('select')}} </option>
                    <option value="budget">{{ $t('budget')}} </option>
                </select>
            </div>
            <div class="mb-3 col-md-4">
                <label class="form-label" for="coreBenefitMethod" required>{{ $t('coreBenefitMethod') }}</label>
                <select v-model="data.coreBenefitMethod" class="form-select">
                    <option value="significant">{{ $t('significantNumber')}} </option>
                    <option value="performance">{{ $t('performance')}} </option>
                </select>
            </div>
            <div class="mb-3 col-md-12">
                <label class="form-label" for="description" required>{{ $t('description') }}</label>
                <input v-model="data.description" type="text" class="form-control" id="description" >
            </div>
        </div>
        <div class="row mb-4">
            <div class="col-2">
                <input class="form-check-input" v-model="data.mandatoryVariants" type="checkbox" id="mandatoryVariants">
                <label class="form-check-label ps-2"  for="mandatoryVariants">
                    {{ $t('mandatoryVariants') }}
                </label>
            </div>
            <div class="col-3">
                <input class="form-check-input" v-model="data.allowBreakLifecycleVariants" type="checkbox" id="allowBreakLifecycleVariants">
                <label class="form-check-label ps-2"  for="allowBreakLifecycleVariants">
                    {{ $t('allowBreakLifecycleVariants') }}
                </label>
            </div>
            <div class="col-3">
                <input class="form-check-input" v-model="data.allowNotFirstVariants" type="checkbox" id="allowNotFirstVariants">
                <label class="form-check-label ps-2"  for="allowNotFirstVariants">
                    {{ $t('allowNotFirstVariants') }}
                </label>
            </div>
        </div>
        <div class="d-grid gap-2 d-md-flex">
            <button type="button" class="btn btn-primary" @click="onSubmit">{{ $t('save') }}</button>
            <button type="button" class="btn btn-secondary" @click="$router.push({ path: `/modeling/${this.$route.params.id}` })">{{ $t('back') }}</button>
        </div>
    </div>
</template>

<script>
import SelectionApi from "../../api/server/selection";

export default {
    name: "selectioncreate",
    watch: {
        $route: "requestData",
    },
    mounted() {
        this.requestData();
    },
    methods: {
        async requestData() {
            this.pending = true;

            this.data.forecastId = this.$route.params.forecastId;

            this.pending = false;
        },
        async onSubmit() {
            try {
                if(this.data.name.length > 0) {
                    this.data.selectionGroup = [{
                        id: 0,
                        name: "All Asset Types",
                        selectionGroupAssetType: []
                    }]

                    await SelectionApi.selectionCreate(this.$route.params.id, this.data);
                    this.showSuccess();
                    this.$router.go(-1);
                } else {
                    this.showEmptyNameError();
                }
            } catch {
                this.showError();
            }
        }
    },
    notifications: {
        showSuccess: {
            title: 'success',
            message: 'selectionCreated',
            type: 'success'
        },
        showError: {
            title: 'error',
            message: 'selectionError',
            type: 'error'
        },
        showEmptyNameError: { 
            title: 'error',
            message: 'emptyName',
            type: 'error'
        }
    },
    data() {
        return {
            data: {
                id: 0,
                name: "",
                description: "",
                mandatoryVariants: false,
                allowBreakLifecycleVariants: false,
                forecastId: 0,
                selectionMethod: "budget",
                coreBenefitMethod: "significant"
            },
            pending: true,
            modelingName: ""
        }
    }
};
</script>